
<div class="competences container-fluid">

  <div class="row header">
    <div class="col-md-1 texte-right">
      NO&nbsp;&nbsp;&nbsp;
    </div>
    <div class="col-md-2 texte-centre">
      &nbsp;&nbsp;CODE
    </div>
    <div class="col-md-8">
      &Eacute;NONC&Eacute; DE COMP&Eacute;TENCE
    </div>
    <div hidden class="col-md-1"></div>
    <div class="col-md-1"></div>
  </div>

  <div id="accordion-competence" class="panel-group" role="tablist" aria-multiselectable="false">
    <div class="panel panel-default" *ngFor="let competence of competences">
      <div class="panel-heading collapsed">
        <div class="row">
          <div class="col-md-1 texte-centre">{{ competence.numero }}</div>
          <div class="col-md-2 texte-centre">{{ competence.code }}</div>
          <div class="col-md-8 competence-name">{{ competence.enonce }}</div>
          <div hidden class="col-md-1">{{ competence.competenceId }}</div>
          <div class="col-md-1">
            <button class="btn btn-secondary btn-sm pull-right" (click)="openDetailsModal(competence)" tooltip="Modifier cette compétence" containerClass="cemeq-tooltip" container="body">Modifier</button>
          </div>
        </div>
      </div>

    </div>
  </div>

  <div class="no-competence alert alert-light" *ngIf="competences != null && competences.length == 0">Il n'y a aucune compétence pour ce programme.</div>
</div>

<button class="btn btn-info details-modal" (click)="openDetailsModal()">Ajouter une comp&eacute;tence</button>

<ngx-loading [show]="loading" [config]="{fullScreenBackdrop:true, animationType:'three-bounce', primaryColour:'#f86c39', secondaryColour:'#808080'}"></ngx-loading>
